import React from "react";
import { Eye, Gauge, Lightbulb, MessageSquareQuote, BoxIcon } from "lucide-react";
import { categoryInfo } from "../../data/clinicalDemo";
import { EntryCategory } from "../../types/clinicalDemo";
export const categoryStyles: Record<EntryCategory, {
  icon: BoxIcon;
  tag: string;
  border: string;
}> = {
  'patient-report': {
    icon: MessageSquareQuote,
    tag: 'bg-sky-50 text-sky-900 border-sky-200',
    border: 'border-sky-300'
  },
  measurement: {
    icon: Gauge,
    tag: 'bg-emerald-50 text-emerald-900 border-emerald-200',
    border: 'border-emerald-300'
  },
  observation: {
    icon: Eye,
    tag: 'bg-lavender-pale text-[#4446A8] border-lavender/30',
    border: 'border-lavender/50'
  },
  interpretation: {
    icon: Lightbulb,
    tag: 'bg-amber-50 text-amber-900 border-amber-200',
    border: 'border-amber-300'
  }
};
export function CategoryTag({
  category
}: {
  category: EntryCategory;
}) {
  const style = categoryStyles[category];
  const Icon = style.icon;
  return <span className={`inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 text-xs font-semibold whitespace-nowrap ${style.tag}`} data-id="element-100" data-mp="2tdk9hqrl7xgz">
      <Icon size={13} aria-hidden="true" data-id="element-101" data-mp="2ol0z12o75ige" />
      {categoryInfo[category].label}
    </span>;
}